<template>
  <div class="page-wrapper">
    <main class="main">
      <div class="page-header">
        <div class="container">
          <h1 class="page-title mb-0">{{ $yuyanbao.denglu }} </h1>
        </div>
      </div>
      <nav class="breadcrumb-nav mb-10 pb-8">
        <div class="container">
          <ul class="breadcrumb">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>{{ $yuyanbao.denglu }}</li>
          </ul>
        </div>
      </nav>
      <div class="page-content">
        <div class="container">
          <div class="login-popup" style="margin: 0 auto">
            <div class="tab tab-nav-boxed tab-nav-center tab-nav-underline">
              <ul class="nav nav-tabs text-uppercase" role="tablist">
                <li class="nav-item">
                  <a href="#sign-in" class="nav-link active">
                    {{ $yuyanbao.denglu }}
                  </a>
                </li>
                <li class="nav-item">
                  <a href="#sign-up" class="nav-link">
                    {{ $yuyanbao.zhuce }}
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="sign-in">
                  <div class="form-group">
                    <label>{{ $yuyanbao.youxiang }} *</label>
                    <input type="text" class="form-control" v-model="denglu.email" required />
                  </div>
                  <div class="form-group mb-0">
                    <label>{{ $yuyanbao.mima }} *</label>
                    <input type="password" class="form-control" v-model="denglu.password" required />
                  </div>
                  <div class="form-checkbox d-flex align-items-center justify-content-between">
                    <input type="checkbox" class="custom-checkbox" v-model="denglu.jizhuwo" required="" />
                    <label for="remember">{{ $yuyanbao.jizhuwo }}</label>
                    <a href="javascrip:void(0);">{{ $yuyanbao.wangjimima }}</a>
                  </div>
                  <button style="width: 100%" class="btn btn-primary" @click="deng_lu_http" :disabled="dengluloading">
                    <div class="btn-text">
                      <i class="w-icon-store-seo mr-1 xuanzhuan" v-if="dengluloading"></i>
                      {{ $yuyanbao.denglu }}
                    </div>
                  </button>
                </div>
                <div class="tab-pane" id="sign-up">
                  <div class="form-group">
                    <label>{{ $yuyanbao.youxiang }} *</label>
                    <input type="text" class="form-control" required v-model="zhuce.email" />
                  </div>
                  <div class="form-group mb-5">
                    <label>{{ $yuyanbao.mima }} *</label>
                    <input type="password" class="form-control" required v-model="zhuce.password" />
                  </div>
                  <button style="width: 100%" class="btn btn-primary" @click="zhu_ce_http" :disabled="zhuceloading">
                    <div class="btn-text">
                      <i class="w-icon-store-seo mr-1 xuanzhuan" v-if="zhuceloading"></i>
                      {{ $yuyanbao.zhuce }}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <el-dialog :title="$yuyanbao.jihuo" :visible.sync="dialog.dialog" width="95%"
      style="max-width: 465px; margin: 0 auto">
      <div v-loading="jihuoloading">
        <div class="form-group">
          <label>{{ $yuyanbao.shurujihuoma }}</label>
          <OtpInput :digits="6" @on-complete="put_jihuo_http" style="margin: 40px auto" />
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <el-button @click="show = !show" type="text" size="mini">
            gengxinyouxiang
          </el-button>
          <el-button type="text" size="mini" @click="put_jihuoma_http" :disabled="jihuomaloading"
            :loading="jihuomaloading">
            chongxinhuoqujihuoma
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="show">
            <div class="form-group">
              <label>Email *</label>
              <input type="text" class="form-control" required v-model="dialog.email" />

              <button style="width: 100%; margin-top: 20px" class="btn btn-primary" @click="put_email_http"
                :disabled="emailloading">
                <div class="btn-text">
                  <i class="w-icon-store-seo mr-1 xuanzhuan" v-if="emailloading"></i>
                  gengxinyouxiang
                </div>
              </button>
            </div>
            <el-divider></el-divider>
          </div>
        </el-collapse-transition>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OtpInput from "otp-input-vue2";
import {
  postZhuCe,
  postDengLu,
  putJiHuo,
  putYongHuEmail,
  putJiHuoMa,
} from "@/api/yonghu";

export default {
  name: "Login",
  components: {
    OtpInput,
  },
  data () {
    return {
      denglu: {
        email: localStorage.getItem("zhanghao"),
        password: localStorage.getItem("mima"),
        jizhuwo: JSON.parse(localStorage.getItem("jizhuwo") || "false"),
      },
      zhuce: {
        email: "",
        password: "",
      },
      zhuceloading: false,
      dengluloading: false,
      dialog: {
        dialog: false,
        yonghu: 0,
        email: "",
      },
      show: false,
      jihuoloading: false,
      emailloading: false,
      jihuomaloading: false,
    };
  },
  methods: {
    zhu_ce_http () {
      if (this.zhuceloading) return;
      const { email, password } = this.zhuce;
      if (this.test_email(email)) return;
      if (this.test_password(password)) return;
      this.zhuceloading = true;
      setTimeout(() => {
        postZhuCe({
          email,
          password,
          yuyan: this.$yuyan,
        })
          .then((data) => {
            if (data.status === "SUCCESSED" && data.data === 0) {
              this.toast({
                icon: "info",
                title: this.$yuyanbao.youxiangyibeishiyong,
              });
            }
            if (data.status === "SUCCESSED" && data.data > 0) {
              this.dialog.dialog = true;
              this.dialog.yonghu = data.data;
              this.dialog.email = email;
            }
            if (data.status === "FAILED")
              this.toast_http({ status: "FAILED" })
          })
          .finally(() => (this.zhuceloading = false));
      }, 500);
    },
    deng_lu_http () {
      if (this.dengluloading) return;
      const { email, password, jizhuwo } = this.denglu;
      if (this.test_email(email)) return;
      if (this.test_password(password)) return;
      this.dengluloading = true;
      setTimeout(() => {
        postDengLu({
          email,
          password,
          yuyan: this.$yuyan,
        })
          .then((data) => {
            // 账号不存在或账号密码不匹配
            if (data.status === "SUCCESSED" && data.data.code === 0) {
              this.toast({
                icon: "info",
                title: this.$yuyanbao.yonghubucunzaihuomimabupipei,
              });
            }
            // 登录成功但账号未激活
            if (data.status === "SUCCESSED" && data.data.code === 1) {
              this.dialog.dialog = true;
              this.dialog.yonghu = data.data.yonghu.id;
              this.dialog.email = email;
            }
            // 登录成功并跳转页面
            if (data.status === "SUCCESSED" && data.data.code === 2) {
              this.toast_http({ status: data.status })
              localStorage.setItem("jizhuwo", jizhuwo);
              localStorage.setItem("zhanghao", jizhuwo ? email : "");
              localStorage.setItem("mima", jizhuwo ? password : "");
              localStorage.setItem("token", data.data.token);
              localStorage.setItem(
                "tokenexp",
                new Date().getTime() + data.data.tokenexp,
              );
              this.$store.commit("set_yonghu", data.data.yonghu);
              this.$router.back();
            }

            // 请求超时或网络出错
            if (data.status === "FAILED")
              this.toast_http({ status: "FAILED" })
          })
          .finally(() => (this.dengluloading = false));
      }, 500);
    },
    test_password (password) {
      if (password === "") {
        this.toast({
          icon: "info",
          title: this.$yuyanbao.mima,
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
        });
        return true;
      }
      return false;
    },
    test_email (email) {
      if (email === "" || !/^[\.a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(email)) {
        this.toast({
          icon: "info",
          title: this.$shezhi.youxiang,
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
        });
        return true;
      }
      return false;
    },
    put_jihuo_http (code) {
      if (this.jihuoloading) return;
      this.jihuoloading = true;
      setTimeout(() => {
        putJiHuo({
          id: this.dialog.yonghu,
          code,
        })
          .then((data) => {
            if (data.status === "SUCCESSED" && data.data.code === 0) {
              this.toast({
                icon: "info",
                title: this.$yuyanbao.jihuomabudui,
              });
            }
            if (data.status === "SUCCESSED" && data.data.code === 1) {
              this.toast_http({ status: data.status })
              localStorage.setItem("token", data.data.token);
              localStorage.setItem(
                "tokenexp",
                new Date().getTime() + data.data.tokenexp,
              );
              this.$store.commit("set_yonghu", data.data.yonghu);
              this.$router.push({
                name: "Index",
              });
            }
            if (data.status === "FAILED")
              this.toast_http({ status: data.status })
          })
          .finally(() => (this.jihuoloading = false));
      }, 500);
    },
    put_email_http () {
      if (this.emailloading) return;
      const { yonghu, email } = this.dialog;
      if (this.test_email(email)) return;
      this.emailloading = true;
      setTimeout(() => {
        putYongHuEmail({
          id: yonghu,
          email,
          yuyan: this.$yuyan,
        })
          .then((data) => {
            if (data.status === "SUCCESSED" && data.data === 0) {
              this.toast({
                icon: "info",
                title: this.$yuyanbao.youxiangyibeishiyong,
              });
            }
            if (data.status === "SUCCESSED" && data.data === 1)
              this.toast_http({ status: data.status })
            if (data.status === "FAILED")
              this.toast_http({ status: data.status })
          })
          .finally(() => (this.emailloading = false));
      }, 500);
    },
    put_jihuoma_http () {
      if (this.jihuomaloading) return;
      const { yonghu, email } = this.dialog;
      this.jihuomaloading = true;
      setTimeout(() => {
        putJiHuoMa({
          id: yonghu,
          email,
          yuyan: this.$yuyan,
        })
          .then((data) => {
            if (data.status === "SUCCESSED" && data.data === 1)
              this.toast_http({ status: data.status })
            else
              this.toast_http({ status: "FAILED" })
          })
          .finally(() => (this.jihuomaloading = false));
      }, 500);
    },
  },
};
</script>

<style scoped>
.btn-text {
  position: relative;
  display: inline-block;
  width: auto;
  padding: 0 25px;
}

.xuanzhuan {
  position: absolute;
  top: 6px;
  left: 5px;
  animation: anixuanzhuan 0.8s infinite linear;
}

.simple-otp-input {
  display: flex;
  align-items: center;
  justify-content: center;
}

.otp-single-input {
  padding: 4px;
  width: 2em;
  height: 2em;
  text-align: center;
}

.single-input-container {
  position: relative;
  margin: 2px;
}

@keyframes anixuanzhuan {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(90deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(270deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
